<template>
  <div class="phone-box">
    <div class="phone-model">
      <div class="phone-menu">
        {{ editing && editing.typeName === 'modules' ? editing.name : '首页' }}
        <img src="../assets/menu.png" />
      </div>
      <div class="phone-content">
        <div class="empty" v-if="designs.length === 0 && !drag">
          <img src="../assets/default.png" />
          <p>从左侧组件库中选择组件，编辑您的企业官网</p>
        </div>
        <draggable v-if="designs.length > 0 || drag" v-model="infoData" :ghostClass="drag ? 'ghost' : ''"
          :group="groupA" animation="300" @start="onStart" @update="handleSolt" @sort="handleSo">
          <transition-group :style="style">
            <div class="designs_box" v-for="(designData, index) in infoData" :key="index">
              <span class="tip_name">{{
                designData.name }}</span>
              <div :class="['component', { mask: editing === designData }]" :is="designData.preview"
                :data="designData.data" @click.native="handleClick($event, designData, index)">
              </div>
              <ul class="ctrl-box" :style="{ top: ctrlBox.top + 'px' }"
                v-if="editing && !editing.typeName && ctrlBox.show && infoIdx === index">
                <li v-if="ctrlBox.showUpBtn" @click="handleUpClick">
                  <i class="fa fa-arrow-up"></i>
                </li>
                <li v-if="ctrlBox.showDownBtn" @click="handleDownClick">
                  <i class="fa fa-arrow-down"></i>
                </li>
                <li @click="handleTimesClick">
                  <i class="fa fa-times"></i>
                </li>
              </ul>
            </div>
          </transition-group>
        </draggable>
      </div>

      <footToolbar :isfooter="footer" @click="handleFooter"></footToolbar>
    </div>

  </div>
</template>
<script>
import { MessageBox } from 'element-ui'
import draggable from 'vuedraggable'
import footToolbar from '../components/footToolbar'
import api from '../api/index'
export default {
  name: 'PhoneBox',
  components: {
    draggable,
    footToolbar
  },
  props: {
    designs: Array,
    editing: Object,
    footer: Object,
    pageType: String,
    drag: Boolean
  },

  data: function () {
    return {
      infoData: [],
      ctrlBox: {
        top: 0,
        chidss: [],
        show: false,
        showUpBtn: true,
        showDownBtn: true,
        targetDesign: null
      },
      visible: false,
      groupA: {
        name: 'itxst',
        pull: false, // 允许拖出,如果设置 字符串'clone' 表示该组拖出的元素会被克隆
        put: true // 允许拖入
      },
      style: 'min-height: 600px; display: block;',
      infoIdx: 0
    }
  },

  watch: {
    editing: {
      handler (newVal, oldVal) {
        // 在这里执行你需要的操作
        this.showPopover()
      }
    },
    drag: {
      handler (newVal, oldVal) {
        console.log('是否拖拽', this.drag)
        if (!this.drag) {
          this.infoData = this.designs
        }
      }
    },
    designs: {
      handler (newVal, oldVal) {
        console.log('设计数据发生变化', newVal, oldVal)
        this.infoData = this.designs
      }
    }
  },

  methods: {
    handleFooter: function (item) {
      console.log('点击底部栏', item)
      this.$emit('click', item)
    },
    handleClick: function (event, designData, index) {
      this.$emit('click', designData)
      if (designData) {
        this.handleMouseOver(event, designData, index)
      }
    },
    showPopover () {
      if (this.editing) {
        const i = this.designs.filter(item => item.type === this.editing.type)
        console.log('显示得数据', i, this.designs, this.editing)
        if (i) {
          i.map(item => {
            item.visible = true
          })
        }
      }
    },
    onStart: function () {
      this.ctrlBox.show = false
    },
    handleMouseOver: function (event, designData, index) {
      console.log('33333333', event.target.top)
      this.ctrlBox.top = event.target.offsetTop
      this.ctrlBox.show = true
      this.infoIdx = index
      this.ctrlBox.showUpBtn = index !== 0
      this.ctrlBox.showDownBtn = index !== this.designs.length - 1
      this.ctrlBox.targetDesign = designData
    },
    handleMouseOut: function () {
      this.ctrlBox.show = false
    },
    handleCtrlBoxMouseOver: function () {
      this.ctrlBox.show = true
    },
    handleCtrlBoxMouseOut: function () {
      this.ctrlBox.show = false
    },
    handleUpClick: function () {
      let index = this.designs.indexOf(this.ctrlBox.targetDesign)
      let thisDesign = this.designs[index]
      let prevDesign = this.designs[index - 1]
      this.$set(this.designs, index, prevDesign)
      this.$set(this.designs, index - 1, thisDesign)
      this.ctrlBox.show = false
    },
    handleDownClick: function () {
      let index = this.designs.indexOf(this.ctrlBox.targetDesign)
      let thisDesign = this.designs[index]
      let nextDesign = this.designs[index + 1]
      this.$set(this.designs, index, nextDesign)
      this.$set(this.designs, index + 1, thisDesign)
      this.ctrlBox.show = false
    },
    handleTimesClick: function () {
      MessageBox.confirm('确定要删除此模块吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.designs.splice(this.designs.indexOf(this.ctrlBox.targetDesign), 1)
        this.ctrlBox.show = false
        this.$emit('delete-item', true)
        // this.editing = null
        // this.handleClick(null)
      })
    },
    handleSolt: function (e) {
      console.log('顺序发生变化', e, this.designs, this.infoData)
      this.$emit('designs-changed', this.infoData)
      this.ctrlBox.chidss = e.target.childNodes
    },
    handleSo: function (e) {
      this.ctrlBox.chidss = e.target.childNodes
      console.log('得到了位置', this.ctrlBox.chidss)
    },
    // 获取数据
    async getIndex () {
      try {
        const data = { uid: '5' } // 需要发送的请求数据
        const response = await api.post('/api/video/sel_user', data)
        console.log('Response:1111111', response)
      } catch (error) {
        console.error('Error sending data:', error)
      }
    }
  },

  created () {
    // this.getIndex();
    console.log('设计数据', this.designs, this.infoData)
    this.infoData = this.designs
  }
}
</script>
<style scoped>
.phone-box {
  background-color: #f0f0f0;
  overflow-y: scroll;
}

.designs_box {
  position: relative;
}

.tip_name {
  cursor: pointer;
  font-size: 12px;
  width: auto;
  min-width: 70px;
  max-width: 90px;
  white-space: nowrap;
  height: 28px;
  border-radius: 3px;
  padding: 0 9px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  box-sizing: border-box;
  position: absolute;
  right: 385px;
  top: 0;
  line-height: 28px;
  color: #63738f;
  /* z-index: 40; */
  text-align: center;
}

.phone-model {
  width: 375px;
  min-height: 700px;
  margin: 40px auto;
  background-color: #fafafa;
  border: 1px solid #c1cddb;
  border-radius: 2px;
  position: relative;
}

.phone-menu {
  position: relative;
  text-align: center;
  font-size: 16px;
  color: #fff;
  background: #1f2d3d;
  height: 41.5px;
  line-height: 41.5px;
}

.phone-content {
  min-height: 600px;
}

.phone-menu img {
  display: block;
  position: absolute;
  right: 12px;
  top: 9px;
  width: 80px;
}

.empty {
  text-align: center;
  font-size: 12px;
  /* margin-top: 150px; */
  color: #324057;
  transform: translateY(100%);
}

.empty img {
  margin: auto;
  display: block;
  width: 120px;
}

.empty p {
  margin-top: 2em;
}

.component {
  position: relative;
  cursor: pointer;
  cursor: pointer;
}

.mask:after {
  display: block;
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  /* background-color: rgba(0,0,0,.5); */
  border: 1px solid #007bfc;
  cursor: default;
  z-index: 999;
}

.component:hover::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
  border: 1px dashed #007bfc;
}

.ctrl-box {
  position: absolute;
  top: 0;
  right: -37px;
  width: 37px;
  background-color: #33343d;
  color: #fff;
  list-style: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
}

.ctrl-box li {
  width: 37px;
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.ctrl-box li:hover {
  background-color: #25262e;
}

/deep/ .el-popover {
  min-width: 78px !important;
  left: -82px;
}

/deep/ .ghost {
  position: relative !important;
  background-color: #68a7f0 !important;
  background-image: linear-gradient(45deg,
      rgba(43, 29, 163, 0.1) 0%,
      transparent 0%,
      transparent 50%,
      rgba(43, 29, 163, 0.1) 50%,
      rgba(43, 29, 163, 0.1) 53%,
      transparent 10%,
      transparent);
  background-size: 20px 20px;
  color: #ffffff;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/PhoneBox.vue